import axios from '../apiEditor';
import qs from 'qs';

export default {
	getMachines() {
		return axios.get().get(`/editor/machines`);
	},

	getMachinesForcID(cID) {
		return axios.get().get(`/editor/machines/cid?cid=${cID}`);
	},

	getMachineById(machineId) {
		return axios.get().get(`/editor/machines/getbyid?id=${machineId}`);
	}
};
